import Axios from 'config/axios';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateConstant } from 'store/actions/constantAction';

const url = '/api/v4/schools/commentCategories';

let loading = false;

const useCommentCategories = () => {
    const COMMENTS = useSelector((state) => state.constants.student_context);
    const dispatch = useDispatch();

    const [student_context, setStudentContext] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            if (COMMENTS) {
                setStudentContext(COMMENTS);
            } else {
                if (loading) return;
                loading = true;
                const response = await Axios.get(url);
                dispatch(updateConstant('student_context', response.data));
                setStudentContext(response.data);
                loading = false;
            }
        };

        fetchData();
    }, [COMMENTS, dispatch]);

    return student_context;
};

export default useCommentCategories;
